function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightSmall = function SvgArrowRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.59.132c-.162-.176-.414-.176-.558 0l-.844.916c-.162.175-.162.448 0 .604l1.168 1.266H.396c-.216 0-.396.195-.396.43v1.305c0 .234.18.429.395.429h3.943l-1.15 1.266c-.162.176-.162.449 0 .604l.844.916c.162.176.414.176.558 0l3.289-3.566c.161-.175.161-.448 0-.604L4.589.132z",
    fill: props.fill
  }));
};
export default SvgArrowRightSmall;